import {Box} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'

export const TextBlock = ({text}: {text: string}) => <span className="text-block">{text}</span>

export const SpaceBlock = () => <span className="delimiter space-delimiter"> </span>

export const Delimiter = ({delimiter}: {delimiter: string}) => <span className="delimiter">{delimiter}</span>

export const KeyBlock = ({text, styles}: {text: string; styles: BetterSystemStyleObject}) => (
  <Box as="span" data-type="filter" sx={styles}>
    {text}
  </Box>
)

try{ TextBlock.displayName ||= 'TextBlock' } catch {}
try{ SpaceBlock.displayName ||= 'SpaceBlock' } catch {}
try{ Delimiter.displayName ||= 'Delimiter' } catch {}
try{ KeyBlock.displayName ||= 'KeyBlock' } catch {}